// ExploreSection

import { Spinner, useThemeMode } from "flowbite-react";
import ApiInfoModal from "../../modals/ApiInfoModal";
import recipeDB_logo from "../../assets/recipeDB_logo.png";
import flavorDB_logo from "../../assets/flavorDB_logo.png";
import sustainableDB_logo from "../../assets/sustainableDB_logo.png";
import dietRx_logo from "../../assets/dietRx_logo.png";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { ArrowLeftCircle, ArrowRightCircle } from "lucide-react";
import { useAuth } from "../../context/AuthContext"; // Update this import path
import { useNavigate } from "react-router-dom";

//add apisList parameter when fetching data from backend
export default function ExploreSection({ content }) {
  const { getToken } = useAuth();
  const navigate = useNavigate();
  const [showLoginMessage, setShowLoginMessage] = useState(false);

  const apisList = [
  {
    _id: "1",
    name: "RecipeDB",
   subapis: [
  { name: "recipesinfo" },
  { name: "recipeofday" },
  { name: "recipe-day/with-ingredients-categories" },
  { name: "nutritioninfo" },
  { name: "micronutritioninfo" },
  { name: "recipes/range" },
  { name: "recipes_cuisine/cuisine/{region}" },
  { name: "recipeByTitle" },
  { name: "calories" },
  { name: "region-diet" },
  { name: "recipe-diet" },
  { name: "recipes-by-carbs" },
  { name: "instructions/{recipe_id}" },
  { name: "meal-plan" },
  { name: "ingredients/flavor/{flavor}" },
  { name: "byutensils/utensils" },
  { name: "recipes-method/{method}" },
  { name: "byenergy/energy" },
  { name: "by-ingredients-categories-title" },
  { name: "category" },
  { name: "search-recipe/{id}" },
  { name: "protein-range" },
  { name: "recipe-Day-category" },
],

  },
  {
    _id: "2",
    name: "FlavorDB",
   subapis: [
  { name: "taste-threshold" },
  { name: "synthesis" },
  { name: "by-tradeAssociationGuidelines" },
  { name: "by-naturalOccurrence" },
  { name: "by-nas" },
  { name: "by-jecfa" },
  { name: "by-iofi-categorisation" },
  { name: "by-flNo" },
  { name: "by-fema" },
  { name: "by-einecs" },
  { name: "by-description" },
  { name: "by-coe" },
  { name: "by-coe-approval" },
  { name: "by-aromaThresholdValues" },
  { name: "by-surfaceArea" },
  { name: "by-rotatableBonds" },
  { name: "by-numberOfAtoms" },
  { name: "by-numRings" },
  { name: "by-energy" },
  { name: "by-aromaticRings" },
  { name: "by-aromaticBonds" },
  { name: "by-alogp" },
  { name: "filter-by-weight-range" },
  { name: "filter-by-weight-from" },
  { name: "filter-by-type" },
  { name: "filter-by-hbd-count" },
  { name: "filter-by-hba-count" },
  { name: "by-topologicalPolarSurfaceArea" },
  { name: "by-pubchemId" },
  { name: "by-monoisotopicMass" },
  { name: "by-heavyAtomCount" },
  { name: "by-functionalGroups" },
  { name: "by-flavorProfile" },
  { name: "by-femaFlavorProfile" },
  { name: "by-commonName" },
  { name: "by-natural-source" },
  { name: "by-name-and-category" },
  { name: "by-entity-alias-readable" },
],

  },
  {
    _id: "3",
    name: "SustainableFoodDB",
    subapis: [
  { name: "search" },
  { name: "by-ingredient" },
  { name: "recipe/{id}" },
  { name: "ingredient-cf" },
  { name: "carbon-footprint-sum" },
  { name: "carbon-footprint" },
  { name: "{name}/carbon-footprint-name" },
],

  },
  {
    _id: "4",
    name: "DietRx",
    subapis: [
  { name: "gene-source/{foodName}" },
  { name: "all-details" },
  { name: "all-details/{association}" },
  { name: "disease-chemicals/{foodName}" },
  { name: "food/{foodName}" },
  { name: "publication/{foodName}" },
  { name: "food-interactions/{foodName}" },
  { name: "chemical-details/{foodName}" },
  { name: "chemical-lexicon/{foodName}" },
  { name: "disease/ctd_disease/{foodName}" },
  { name: "disease/diseaselexicon/{foodName}" },
  { name: "disease/publicationsDisease/{diseaseName}" },
  { name: "disease/{diseaseName}" },
],

  },
];



  useEffect(() => {
    AOS.init({
      duration: 700,      // animation duration
      offset: 100,        // trigger point from the top
      once: true,         // animate only once
      easing: 'ease-in-out',
    });
  }, []);

  const temp_api_data = {
    RecipeDB: {
      short_description: "118,000+ recipes from across the globe.",
      long_description:
        "Ingredient composition, quantities, nutrition profiles, cuisines, and other attributes of over 118,000 recipes from 26 world regions.",
      image: recipeDB_logo,
      link: "https://documenter.getpostman.com/view/25274592/2s93ecvVAd",
          comingSoon: false,

    },
    FlavorDB: {
      short_description: "Flavor profiles of ~1,000 natural ingredients.",
      long_description:
        "Flavor molecule constitution, taste/odor profiles, nomenclatures, and chemical descriptors of 934 natural ingredients across 36 categories.",
      image: flavorDB_logo,
      link: "",
          comingSoon: false,

    },
    SustainableFoodDB: {
      short_description: "Environmental impact for 500+ foods.",
      long_description:
        "Detailed data on carbon footprint, water usage, and sustainability indexes for hundreds of food products to promote eco-conscious choices.",
      image: sustainableDB_logo,
      link: "#",
          comingSoon: true,

    },
    DietRx: {
      short_description: "Food recommendations for 100+ diseases.",
      long_description:
        "A curated database connecting dietary ingredients and food items with clinical evidence for therapeutic use across various health conditions.",
      image: dietRx_logo,
      link: "#",
          comingSoon: true,

    },
  };

  // Handle the "Try it now" button click
  const handleTryItNowClick = (e) => {
    e.preventDefault();
    
    // Check if user is logged in
    const token = getToken();
    
    if (token && token !== 0) {
      // User is logged in, navigate to playground
      navigate("/playground");
    } else {
      // Show login message
      setShowLoginMessage(true);
      
      // Optional: automatically hide message after some time
      setTimeout(() => {
        setShowLoginMessage(false);
      }, 5000); // Hide after 5 seconds
    }
  };

  return (
    <section id="about" className="bg-white dark:bg-gray-900 pl-0 xl:pl-10">
      <div className="container px-6 py-12 mx-auto">
        <div data-aos="fade-up">
          <h1
            data-aos="fade-right"
            className="text-2xl text-center md:text-start font-semibold text-gray-800 capitalize lg:text-3xl dark:text-white"
          >
            {content.explore.heading}
          </h1>

          <p className="mt-4 text-gray-500 xl:mt-6 dark:text-gray-300 text-center md:text-start">
            {content.explore.subheading}
          </p>
          <div className="flex justify-end items-center gap-4 mt-6">
            <button className="swiper-button-prev-custom text-gray-700 dark:text-white hover:text-primary transition">
              <ArrowLeftCircle size={32} />
            </button>
            <button className="swiper-button-next-custom text-gray-700 dark:text-white hover:text-primary transition">
              <ArrowRightCircle size={32} />
            </button>
          </div>

          {apisList.length == 0 ? (
            <div className="flex items-center justify-center w-full h-48">
              <Spinner aria-label="Left-aligned spinner example" size="lg" />
            </div>
          ) : (
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-900/10 to-indigo-900/10 z-0 rounded-2xl blur-lg"></div>

              <Swiper
                spaceBetween={30}
                grabCursor={true}
                pagination={{ clickable: true }}
                navigation={{
                  prevEl: ".swiper-button-prev-custom",
                  nextEl: ".swiper-button-next-custom",
                }}
                simulateTouch={true}
                allowTouchMove={true}
                loop={true}
                autoplay={{
                  delay: 1000,
                  pauseOnMouseEnter: true,
                 
                }}
                breakpoints={{
                  640: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                }}
                modules={[Pagination, Navigation, Autoplay]}
                className="mt-8 lg:mt-12 pb-16 relative z-10"
              >
                {apisList.map((api, index) => {
                  const data = temp_api_data[api.name];
                  if (!data) return null; // safeguard in case api.name doesn't match

                  return (
                    <SwiperSlide key={api._id} className="pt-4 overflow-visible">
                      <div data-aos="fade-up" data-aos-delay={index * 150}>
                        <ApiInfoModal
                          name={api.name}
                          short_description={data.short_description}
                          long_description={data.long_description}
                          imageUrl={data.image}
                          link={data.link}
                          subapis={api.subapis}
                          comingSoon={data.comingSoon}
                        />
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          )}
        </div>
        <div className="flex flex-col md:flex-row items-center gap-4 mt-8">
          <motion.button
            onClick={handleTryItNowClick}
            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-slate-100 bg-gradient-to-r from-indigo-500 to-blue-500 rounded-full shadow-lg hover:shadow-blue-500/40 transition duration-300"
            whileHover={{ x: 6, scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Try it now
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </motion.button>
          
          {showLoginMessage && (
            <motion.span
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-sm text-red-500 dark:text-red-400"
            >
              Please log in to access the playground
            </motion.span>
          )}
        </div>
      </div>
    </section>
  );
}